import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import Swiper, { Navigation, Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

// const elements = document.querySelectorAll('.js-entrance .swiper-slide');
// const elementsArray = Array.from(elements);
// const shuffledArray = elementsArray.sort(() => Math.random() - 0.5);
// const container = document.querySelector('.js-entrance .swiper-wrapper');
// container.innerHTML = '';
// shuffledArray.forEach(element => container.appendChild(element));

const swiperExhibition = new Swiper('.js-entrance', {
  modules: [Navigation, Autoplay],
  speed: 600,
  autoplay: {
    delay: 3000,
  },
  loop: true,
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 40,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

if(document.querySelector('.js-slider')) {
  const index = document.querySelector('.js-slider').getAttribute('data-index');

  const swiperSingle = new Swiper('.js-slider', {
    modules: [Navigation],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    initialSlide: Number(index) >= 10 ? Number(index) - 10 : Number(index),
    speed: 600,
    // autoplay: 500,
    loop: true,
    loopedSlides: 7,
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 10,
    loopAdditionalSlides: 12,
    observer: true,
    observeParents: true,

  });
}
